import Grid from '@mui/material/GridLegacy';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

interface SubscriptionWarningProps {
    message: string;
    linkText: string;
    className: string;
}

const HELP_URL = 'https://help.seequent.com/Imago/en-GB/Content/intro.htm#sign-in';

export const SubscriptionWarning = ({ message, linkText, className }: SubscriptionWarningProps) => (
    <Grid className={className}>
        <Typography color="inherit" variant="h5">
            {message} <Link href={HELP_URL}>{linkText}</Link>.
        </Typography>
    </Grid>
);
